<template>
  <BaseCustomizeMetal componentCode="AD" />
</template>
<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalAD",
  components: {
    BaseCustomizeMetal,
  },
};
</script>
<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 114px;
    left: 141px;
    @include betweenTableTablePro {
      top: 79px;
      left: 91px;
    }
    @include table {
      top: 60px;
      left: 65px;
    }
    @include phone {
      top: 49px;
      left: 50px;
    }
  }
  .templeName {
    height: 33px;
    width: 194px;
    .textContainer {
      width: 194px;
    }
  }
  .godName {
    width: 216px;
    height: 38px;
    .textContainer {
      width: 216px;
    }
  }
  .gift {
    width: 172px;
    height: 26px;
    .textContainer {
      width: 172px;
    }
  }
}
</style>
